/**
 * @desc 发起权限申请审批
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<string>;
export function request(
  body: defs.appCenter.BizPermissionApplyRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApply/startApproval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
